const mobileGrid = "sm:hidden grid grid-cols-2 gap-2";

const desktopTable = "hidden sm:table w-full";

const mobileCardHeader = "flex items-center justify-between mb-2";

const mobileTapText = "text-xs font-medium text-muted-foreground";

const inlineFlexGap1_5 = "inline-flex items-center gap-1.5";

const inlineFlexGap0_5 = "inline-flex items-center gap-0.5";

const iconH3_5W3_5TextMuted = "h-3.5 w-3.5 text-muted-foreground/60";

const iconH4W4TextMuted = "h-4 w-4 text-muted-foreground";

const badgeIcon = "mr-1 inline h-3 w-3";

const providerValue = "inline-flex items-center gap-1.5 text-foreground";

export {
  mobileGrid,
  desktopTable,
  mobileCardHeader,
  mobileTapText,
  inlineFlexGap1_5,
  inlineFlexGap0_5,
  iconH3_5W3_5TextMuted,
  iconH4W4TextMuted,
  badgeIcon,
  providerValue,
};
